var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BasePageWrapper',{attrs:{"title-align":"center","content-space":"","display":"block"}},[_c('PhotoList',{attrs:{"images":_vm.normalizeList},on:{"remove-first":_vm.removeFirstPhoto}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }